import {GTM_ID} from '../../shared/config/config';

const initGoogleTracking = () => {
  // Setup GA
  const tag = document.createElement('script');
  tag.src = 'https://www.google-analytics.com/analytics.js';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // Default GTM setup, borrowed from https://developers.google.com/tag-manager/quickstart
  ((w, d, s, l, i) => {
    w[l] = w[l] || [];
    w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = `//www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', GTM_ID);
};

export default initGoogleTracking;
